<template>
    <!--员工档案-基本信息-->
    <div
        style=" width: 100%;font-size: 14px;height:100%;padding-left:12px;padding-right:12px;box-sizing:border-box;">
        <div v-for="(row, indey) in arr" :key="indey">
            <div style="display: flex;justify-content: center;width:100%;padding-top:30px">
                <div class="title" style="font-size: 28px;">应聘人员履历表</div>
            </div>
            <table width="100%" height="100%" cellpadding="0" cellspacing="0" class="table1" border=0
                style="border-collapse: collapse;border-spacing:0;border:none;margin-top: 8px;table-layout:fixed;word-break:break-word;border:1px solid rgb(128 128 128)">
                <tr class="border-b">
                    <td  colspan="4" class="border-r" style="background-color: #E7EDF8;">
                        <div align="center">应聘岗位</div>
                    </td>
                    <td colspan="8" class="border-r">{{
                        findLabel('recruit_post', row.recruitPost) }}</td>
                    <td  colspan="4" class="border-r" style="background-color: #E7EDF8;">
                        <div align="center">填表日期</div>
                    </td>
                    <td colspan="8" class="border-n">{{
                        row.createdTime.split('-')[0] }}年{{ row.createdTime.split('-')[1] }}月{{
        row.createdTime.split('-')[2]
    }}日
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">姓名</div>
                    </td>
                    <td colspan="2" class="border-b-r">{{ row.name }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">性别</div>
                    </td>
                    <td colspan="2" class="border-b-r">{{ row.gender == 1 ? '男' : '女' }}
                    </td>
                    <td colspan="2" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">民族</div>
                    </td>
                    <td colspan="2" class="border-b-r">{{ row.nation }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">籍贯</div>
                    </td>
                    <td colspan="4" class="border-b-r">{{ row.nativePlace }}</td>
                    <td colspan="4" rowspan="5" class="border-n">
                        <div style="display: flex;justify-content: center;">
                            <img class="avatar" style="width: 90px;height: 120px; object-fit: cover;" :src="row.image" v-if="row.image" />
                        </div>


                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">属相</div>
                    </td>
                    <td colspan="2" class="border-b-r">{{ findLabel('zodiac', row.zodiac) }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">身高(cm)</div>
                    </td>
                    <td colspan="2" class="border-b-r">{{ row.height }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">体重(kg)</div>
                    </td>
                    <td colspan="2" class="border-b-r">{{ row.weight }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;" class="border-b-r">
                        <div align="center">出生日期</div>
                    </td>
                    <td colspan="4" class="border-b-r">{{
                        row.dateOfBirth }}</td>
                </tr>
                <tr>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">政治面貌</div>
                    </td>
                    <td colspan="4" >{{ findLabel('political_affiliation', row.politicalAffiliation) }}
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">联系电话</div>
                    </td>
                    <td colspan="8">{{ row.phone }}</td>
                </tr>
                <tr class="border-b">
                    <td colspan="4" rowspan="2" style="background-color: #E7EDF8;">
                        <div align="center">婚姻状况</div>
                    </td>
                    <td colspan="4" rowspan="2">
                        <!-- <div style="display:flex;justify-content:flex-start;align-items:center;margin-top:-16px;margin-left:8px;flex-wrap:wrap"> -->
                            <span v-for="(item, indz) in dictionaries.marital_status" :key="indz"
                                style="margin-right:4px;min-width:44px" v-if="item.dictId == row.maritalStatus">
                                <!-- <input type="checkbox" name="checkbox" :checked="item.dictId == row.maritalStatus" /> -->
                                {{item.dictName }}
                            </span>
                        <!-- </div> -->
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;" >
                        <div align="center">微信号</div>
                    </td>
                    <td colspan="8"> {{ row.wechatNumber }}</td>
                </tr>
                <tr class="border-b" >
                    <td colspan="4" style="background-color: #E7EDF8;">
                        邮箱地址
                    </td>
                    <td colspan="8">{{ row.email }}</td>
                </tr>
                <tr class="border-b">
                    <td  colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">最高学历</div>
                    </td>
                    <td colspan="4" >{{ findLabel('educational_level', row.educationalLevel) }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">期待薪资</div>
                    </td>
                    <td colspan="4">{{ row.desiredSalary }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">可到岗日期</div>
                    </td>
                    <td colspan="4" class="border-n">{{ row.availableTime }}</td>
                </tr>
                <tr class="border-b">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">身份证号码</div>
                    </td>
                    <td colspan="8">{{ row.idCardNumber }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">户口性质</div>
                    </td>
                    <td colspan="8" class="border-n">
                        <!-- <input type="checkbox" name="checkbox" value="checkbox" :checked="row.householdType == 2" />城镇
                        <input type="checkbox" name="checkbox" value="checkbox" :checked="row.householdType == 1" />农村 -->
                        <span v-if="row.householdType == 1">农村户口</span>
                        <span v-else-if="row.householdType == 2">城镇户口</span>
                    </td>
                </tr>
                <tr class="border-b">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">身份证详细地址</div>
                    </td>
                    <td colspan="8" >
                        <div style="line-height: 1.3; padding: 4px 0;">{{ row.householdResidenceDetail }}</div></td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">居住地详细地址</div>
                    </td>
                    <td colspan="8" class="border-n"><div style="line-height: 1.3; padding: 4px 0;">{{ row.currentResidenceDetail }}</div></td>
                </tr>
                <tr class="border-b">
                    <td colspan="6" style="background-color: #E7EDF8;">
                        <div align="center" style="line-height: 1.3;">是否有朋友/亲戚在本公司服务</div>
                    </td>
                    <td colspan="2">
                        <!-- <input type="checkbox" name="checkbox" value="checkbox" :checked="row.kinFlag == 1" />是
                        <input type="checkbox" name="checkbox" value="checkbox" :checked="row.kinFlag == 0" />否 -->
                        <span v-if="row.kinFlag == 1">是</span>
                        <span v-else-if="row.kinFlag == 0">否</span>
                    </td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        <div align="center">姓名</div>
                    </td>
                    <td colspan="4">{{ row.kinName }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        <div align="center">关系</div>
                    </td>
                    <td colspan="2" >{{ row.kinRelationship }}</td>
                    <td colspan="2" style="background-color: #E7EDF8;">
                        <div align="center">部门</div>
                    </td>
                    <td colspan="4" class="border-n">{{ row.kinOrganization }}</td>
                </tr>
                <tr class="border-b">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">爱好/专长</div>
                    </td>
                    <td colspan="12">{{ row.hobby }}</td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">汽（机）车驾照</div>
                    </td>
                    <td colspan="4" class="border-n">{{ findLabel('driving_license_level',
                        row.drivingLicenseLevel) }}</td>
                </tr>

                <tr class="border-b" v-if="row.educationList.length != 0" style="background-color: #E7EDF8;">
                    <td  colspan="4" :rowspan="row.educationList.length + 1"  style="background-color: #E7EDF8;">
                        <div align="center" style="line-height: 1.3;">教育经历<br/>（从高到低）</div>
                    </td>
                    <td colspan="4">
                        <div align="center">起止时间</div>
                    </td>
                    <td colspan="6">
                        <div align="center">学校名称</div>
                    </td>
                    <td colspan="4">
                        <div align="center">专业</div>
                    </td>
                    <td colspan="2">
                        <div align="center">学历</div>
                    </td>
                    <td colspan="4"  class="border-n">
                        <div align="center">教育类型</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.educationList" class="border-b">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1; padding: 4px 0; font-size: 13px;">{{ item.startTime }}<span style="font-size: 12px;">至</span><br/>{{ item.endTime }}</div>
                        </td>
                        <td colspan="6"><div style="line-height: 1.2; padding: 4px 0;">{{ item.institutionName }}</div></td>
                        <td colspan="4"><div style="line-height: 1.2; padding: 4px 0;">{{ item.major }}</div></td>
                        <td colspan="2">{{ findLabel('educational_level', item.educationalLevel) }}</td>
                        <td colspan="4" class="border-n">{{ findLabel('educational_mode',
                            item.educationalMode) }}</td>

                    </template>
                    <template v-else>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="6">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="2">&nbsp;</td>
                        <td colspan="4"  class="border-n">&nbsp;</td>
                    </template>
                </tr>


                <tr v-if="row.workRecordList.length != 0" class="border-b" style="background-color: #E7EDF8;">
                    <td colspan="4" :rowspan="row.workRecordList.length + 1" style="background-color: #E7EDF8;">
                        <div align="center" style="line-height: 1.3;">工作经历<br/>(从近到远)</div>
                    </td>
                    <td colspan="4">
                        <div align="center">起止时间</div>
                    </td>
                    <td colspan="4">
                        <div align="center">单位名称</div>
                    </td>
                    <td colspan="4">
                        <div align="center">任职部门及职位名称</div>
                    </td>
                    <td colspan="3">
                        <div align="center">离职原因</div>
                    </td>
                    <td colspan="3">
                        <div align="center">证明人及其电话</div>
                    </td>

                    <td colspan="2" class="border-n">
                        <div align="center">月薪</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.workRecordList" class="border-b">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1;padding: 4px 0;font-size: 13px;">{{ item.startTime }}<span style="font-size: 12px;">至</span><br/>{{ item.endTime }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.company }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.organization }}<br/>{{ item.post }}</div>
                        </td>
                        <td colspan="3">{{ findLabel('resignation_reason', item.resignationReason) }}</td>
                        <td colspan="3">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.certifier }}<br/>{{ item.phone }}</div></td>
                        <td colspan="2"  class="border-n">{{ item.salary }}</td>
                    </template>
                    <template v-else>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="3">&nbsp;</td>
                        <td colspan="3">&nbsp;</td>
                        <td colspan="2"  class="border-n">&nbsp;</td>
                    </template>
                </tr>

                <tr v-if="row.trainingInfoList.length != 0" class="border-b" style="background-color: #E7EDF8;">
                    <td colspan="4" :rowspan="row.trainingInfoList.length + 1"  style="background-color: #E7EDF8;">
                        <div align="center">培训经历</div>
                    </td>
                    <td colspan="4">
                        <div align="center">起止时间</div>
                    </td>
                    <td colspan="4">
                        <div align="center">培训机构</div>
                    </td>
                    <td colspan="4">
                        <div align="center">获取证书</div>
                    </td>
                    <td colspan="4">
                        <div align="center">培训方式</div>
                    </td>
                    <td colspan="4" class="border-n">
                        <div align="center" >培训内容</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.trainingInfoList" class="border-b">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1;padding: 4px 0; font-size: 13px;">{{ item.startTime }}<span style="font-size: 12px;">至</span><br/>{{ item.endTime }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.institutionName }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.certificate }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ findLabel('training_mode', item.trainingMode) }}</div>
                        </td>
                        <td colspan="4" class="border-n">
                            <div style="line-height: 1.2;padding: 2px 0;">{{ item.trainingContent }}</div>
                        </td>

                    </template>
                    <template v-else>
                        <td colspan="2">&nbsp;</td>
                        <td colspan="2">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4" class="border-n">&nbsp;</td>
                    </template>
                </tr>
                <tr v-if="row.familyInfoList.length != 0" class="border-b" style="background-color: #E7EDF8;">
                    <td :rowspan="row.familyInfoList.length + 1" colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">家庭成员</div>
                    </td>
                    <td colspan="4">
                        <div align="center">姓名</div>
                    </td>
                    <td colspan="4">
                        <div align="center">关系</div>
                    </td>
                    <td colspan="4">
                        <div align="center">工作单位</div>
                    </td>
                    <td colspan="4">
                        <div align="center">职务</div>
                    </td>
                    <td colspan="4" class="border-n">
                        <div align="center">联系电话(区+号码)</div>
                    </td>
                </tr>
                <tr v-for="(item, index) in row.familyInfoList" class="border-b">
                    <template v-if="item">
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ item.name }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ findLabel('family_relationships', item.familyRelationships) }}</div>
                        </td>
                        <td colspan="4" >
                             <div style="line-height: 1.2;padding: 6px 0;">{{ item.company }}</div>
                        </td>
                        <td colspan="4">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ item.post }}</div>
                        </td>
                        <td colspan="4" class="border-n">
                            <div style="line-height: 1.2;padding: 6px 0;">{{ item.phone }}</div>
                        </td>

                    </template>
                    <template v-else>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4">&nbsp;</td>
                        <td colspan="4" class="border-n">&nbsp;</td>
                    </template>
                </tr>
                <tr class="border-b">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">紧急联系人姓名</div>
                    </td>
                    <td colspan="8">
                        <div align="center">{{ row.emergencyContactName }}</div>
                    </td>
                    <td colspan="4">
                        <div align="center">紧急联系人电话</div>
                    </td>
                    <td colspan="8" class="border-n">
                        <div align="center">{{ row.emergencyContactPhone }}</div>
                    </td>
                </tr>
                <tr class="border-b">
                    <td colspan="6" style="background-color: #E7EDF8;">
                        <div align="center" style="line-height: 1.2;padding: 6px 0;">原单位是否存在纠纷</div>
                    </td>
                    <td colspan="2">
                        <!-- <div align="center">
                            <input type="checkbox" name="checkbox" value="checkbox" :checked="row.dispute != ''" />是
                            <input type="checkbox" name="checkbox" value="checkbox"
                                :checked="row.dispute == '' || row.dispute == null" />否
                        </div> -->
                        <span v-if="row.dispute != ''">是</span>
                        <span v-else-if="row.dispute == '' || row.dispute == null">否</span>
                    </td>
                    <td colspan="4" style="background-color: #E7EDF8;">
                        纠纷内容
                    </td>
                    <td colspan="12" class="border-n">
                        <div align="center"  style="line-height: 1.2;padding: 6px 0;">
                            {{ row.dispute }}
                        </div>
                    </td>
                </tr>
                <tr class="border-b">
                    <td colspan="4" style="background-color: #E7EDF8;">
                        <div align="center">招聘信息来源</div>
                    </td>
                    <td colspan="20" class="border-n">
                        <!-- <div align="center">
                            <div
                                style="display:flex;justify-content:flex-start;align-items:center;margin-top:-16px;margin-left:8px;flex-wrap:wrap">
                                <div v-for="(item, indz) in dictionaries.recruit_origin" :key="indz"
                                    style="margin-right:10px">
                                    <input type="checkbox" name="checkbox" :checked="item.dictId == row.recruitOrigin" />{{
                                        item.dictName }}
                                </div>
                            </div>
                        </div> -->
                        <span v-for="(item, indz) in dictionaries.recruit_origin" :key="indz">
                            <span v-if="item.dictId == row.recruitOrigin">{{ item.dictName }}</span>
                        </span>
                    </td>
                </tr>
                <tr style="font-size: 12px;">
                    <td colspan="24" class="border-n">
                        <div>应聘者需对以上填写资料真实性负责，我们会根据相关资料进行调查，如有不实，后果由应聘者自行承担</div>
                    </td>
                </tr>
                <tr>
                    <td rowspan="2" colspan="16" class="border-n1">
                        <div align="center" style="color:#999999;font-size: 14px;">请各位应聘者确保以上信息真实有效，确认无误请签字</div>
                    </td>
                    <td colspan="2">姓名：</td>
                    <td colspan="6"  class="border-n">&nbsp;</td>
                </tr>
                <tr>
                    <td colspan="2" class="border-n1">日期：</td>
                    <td colspan="6"  class="border-n border-n1">&nbsp;</td>
                </tr>
            </table>
            <table width="100%" height="100%" cellpadding="0" cellspacing="0" class="table1" border=0
            style="border-collapse: collapse;border-spacing:0;border:none;table-layout:fixed;word-break:break-word;border:none">
            <tr>
                <td colspan="24" style="height: 40px;" class="border-n"></td>
            </tr>
            <tr>
                    <td colspan="4" rowspan="3" class="border-left" style="text-align: center; background-color: #E7EDF8; height: 222px;">
                        <div>行政人事意见</div>
                    </td>
                    <td colspan="20" style="vertical-align:top; text-align: left; padding: 8px 6px; ">
                        <div>优势：</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>不足：</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="20">
                        <div style="padding:8px 6px; text-align: left;">
                            <span style="padding-right: 6px;">结论：</span>
                            <input type="checkbox" name="checkbox" value="checkbox" style="vertical-align:middle;" />
                            <span style="margin:0 24px 0 2px;">通知</span>
                            <input type="checkbox" name="checkbox2" value="checkbox"  style="vertical-align:middle;"/>
                            <span style="margin:0 24px 0 2px;">不通知</span>
                            <input type="checkbox" name="checkbox3" value="checkbox"  style="vertical-align:middle;"/>
                            <span style="margin:0 0 0 2px;">待定</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="10" style="text-align: left;">
                        <div style="padding: 8px 6px;">签名：</div>
                    </td>
                    <td colspan="10" style="text-align: left;">
                        <div style="padding: 8px 6px;">日期：</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="4" rowspan="3" style="text-align: center; background-color: #E7EDF8; height: 222px;" class="border-left" >
                        <div style="line-height: 1.2;">用人部门面试意见<br/>(必填)</div>
                    </td>
                    <td colspan="20" style="vertical-align:top; padding: 8px 6px; text-align: left;" >
                        <div>优势：</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>不足：</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="10">
                        <div style="padding:8px 6px; text-align: left;">
                            <span style="padding-right: 6px;">结论：</span>
                            <input type="checkbox" name="checkbox" value="checkbox" style="vertical-align:middle;" />
                            <span style="margin:0 24px 0 2px;">通知</span>
                            <input type="checkbox" name="checkbox2" value="checkbox"  style="vertical-align:middle;"/>
                            <span style="margin:0 24px 0 2px;">不通知</span>
                            <input type="checkbox" name="checkbox3" value="checkbox"  style="vertical-align:middle;"/>
                            <span style="margin:0 0 0 2px;">待定</span>
                        </div>
                    </td>
                    <td colspan="10">
                        <div style="padding:8px 6px;text-align: left;">
                            <span style="padding-right: 6px;">简历是否合格：</span>
                            <input type="checkbox" name="checkbox" value="checkbox" style="vertical-align:middle;" />
                            <span style="margin:0 24px 0 2px;">是</span>
                            <input type="checkbox" name="checkbox2" value="checkbox" style="vertical-align:middle;" />
                            <span style="margin:0 0 0 2px;">否</span>
                        </div>
                    </td>
                </tr>
                <tr >
                    <td colspan="10" style="text-align: left;" >
                        <div style="padding: 8px 6px;">签名：</div>
                    </td>
                    <td colspan="10"  style="text-align: left;">
                        <div style="padding: 8px 6px;">日期：</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="4" rowspan="3" style="text-align: center; background-color: #E7EDF8; height: 222px;" class="border-left">
                        <div>总经理批示</div>
                    </td>
                    <td colspan="20" style="vertical-align:top; padding: 8px 6px;text-align: left;" >
                        <div>优势：</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>不足：</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="20">
                        <div style="padding:8px 6px; text-align: left;">
                            <span style="padding-right: 6px;">结论：</span>
                            <input type="checkbox" name="checkbox" value="checkbox" style="vertical-align:middle;" />
                            <span style="margin:0 24px 0 2px;">通知</span>
                            <input type="checkbox" name="checkbox2" value="checkbox"  style="vertical-align:middle;"/>
                            <span style="margin:0 24px 0 2px;">不通知</span>
                            <input type="checkbox" name="checkbox3" value="checkbox"  style="vertical-align:middle;"/>
                            <span style="margin:0 0 0 2px;">待定</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="10" style="text-align: left;" >
                        <div style="padding: 8px 6px;">签名：</div>
                    </td>
                    <td colspan="10" style="text-align: left;">
                        <div style="padding: 8px 6px;">日期：</div>
                    </td>
                </tr>
            </table>
        </div>

    </div>
</template>

<script>
export default {
    name: 'baseStaffRecordDetail',
    props: {
        currentRow: {
            type: Array,
            default() {
                return []
            }
        },
    },
    components: {

    },
    created() {
        this.dictionaries = this.fmObjToArr(JSON.parse(sessionStorage.getItem('dictionaries')))
        this.dict('recruit_post')
        this.dict('recruit_origin')
        this.dict('job_nature')
        this.dict('recruit_type')
        this.dict('zodiac')
        this.dict('educational_type')
        this.dict('marital_status')
        this.dict('driving_license_level')
        this.dict('political_affiliation')
        this.dict('household_type')
        this.dict('resignation_reason')
        this.dict('educational_mode')
        this.dict('educational_level')
        this.dict('family_relationships')
        this.dict('training_mode')
    },
    mounted() {

    },
    watch: {
        currentRow(val) {
            val.forEach((item) => {
                if (item.familyInfoList) {
                    item.familyInfoList.forEach((itm) => {
                        if (itm.emergencyFlag == 1) {
                            item.jName = itm.name
                            item.jPhone = itm.phone
                        } else {
                            item.jName = null
                            item.jPhone = null
                        }

                    })
                }
            })
            this.arr = val
            console.log(this.arr)
        }
    },
    data() {
        return {
            // row: {},
            result: "",
            sex: ['', '男', '女'],
            arr: [

            ],
            dictionaries: {}
        }
    },
    methods: {
        dict(val) {
            this.dictionaries.forEach((item) => {
                console.log(item)
                if (item.value == val) {
                    this.dictionaries[val] = item.label
                }
            })
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            console.log(arr)
            return arr
        },
        findLabel(label, val) {
            let dictName = ''
            return dictName = this.dictionaries[label].find(item => item.dictId == val).dictName
        },

    }
}
</script>
<style>
.table1 {
    border-top: rgb(128 128 128) 1px solid;
    border-left: rgb(128 128 128) 1px solid;
    border-right: none;
    border-bottom: none;
}

.table1 td {
    border-right: rgb(128 128 128) 1px solid;
    border-bottom: rgb(128 128 128) 1px solid;
    text-align: center;
    line-height: 32px;
    vertical-align: middle;
}

.border-n {
    border-right: none !important;
}

.border-n1 {
    border-bottom: none !important;
}
.border-left{
    border-left: rgb(128 128 128) 1px solid;
}

/* .border-b {
    border-bottom:  1px solid rgb(128 128 128);
    box-shadow: none !important;
}

.border-r {
    border-right: 1px solid rgb(128 128 128)
}

.border-b-r {
    border-right: 1px solid rgb(128 128 128);
    border-bottom: 1px solid rgb(128 128 128)
} */

/* input[type=checkbox] {
    width: 16px;
    height: 16px;
    margin-top: 2px;
    position: relative;
}

input[type=checkbox]::after {
    position: absolute;
    top: 0;
    color: #000;
    width: 16px;
    height: 16px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: ' ';
    border-radius: 3px;
}

input[type=checkbox]:checked::after {
    content: "✓";
    color: #fff;
    font-size: 10px;
    line-height: 15px;
    background-color: #42BEAD;
} */
</style>
